export default {
  title: 'Phone Verification',
  description: 'This phone number is already registered. We can send you a verification code to confirm it\'s yours and update your account information.',
  phoneLabel: 'Phone Number',
  sendCode: 'Send Verification Code',
  enterCode: 'Enter the 6-digit code sent to {phone}',
  codeLabel: 'Verification Code',
  codePlaceholder: '000000',
  verify: 'Verify & Update Account',
  didntReceive: 'Didn\'t receive the code?',
  resend: 'Resend',
  resendIn: 'Resend available in {seconds} seconds',
  codeSent: 'Verification code sent successfully',
  success: 'Phone verified successfully! Your account has been updated.',
  sendError: 'Failed to send verification code. Please try again.',
  verifyError: 'Failed to verify code. Please try again.',
  invalidCode: 'Invalid verification code',
  invalidCodeLength: 'Please enter a 6-digit code',
  codeExpired: 'Verification code has expired. Please request a new one.',
  phoneExistsTitle: 'Phone Number Already Registered',
  phoneExistsMessage: 'This phone number is already associated with an account. Would you like to verify it\'s yours and update the account information?',
  verifyButton: 'Verify Phone Number',
  confirmUpdate: 'Confirm Account Update',
  confirmDescription: 'Review the changes below. Your account will be updated with the new information.',
  field: 'Field',
  currentValue: 'Current Value',
  newValue: 'New Value',
  confirmButton: 'Update My Account',
  updateCancelled: 'Account update cancelled',
  confirmError: 'Failed to update account. Please try again.'
}